import React from 'react'

import ErrorUpdatingCartMessage from '../ErrorUpdatingCartMessage'
import { MutationErrorAlert } from '../MutationErrorAlert'

export interface UpdateCartItemErrorAlertProps {
  className?: string
  onCancel(e?: React.BaseSyntheticEvent): void
  onRetry(e?: React.BaseSyntheticEvent): void
}

const UpdateCartItemErrorAlert: React.FC<UpdateCartItemErrorAlertProps> = ({
  className,
  onCancel,
  onRetry,
}) => {
  return (
    <MutationErrorAlert
      cancelButtonText="Cancel Update"
      className={className}
      onCancel={onCancel}
      onRetry={onRetry}
    >
      <ErrorUpdatingCartMessage withoutContactSupport />
    </MutationErrorAlert>
  )
}

export default UpdateCartItemErrorAlert
